import { render, staticRenderFns } from "./exhibit.vue?vue&type=template&id=e010055e&scoped=true&"
import script from "./exhibit.vue?vue&type=script&lang=js&"
export * from "./exhibit.vue?vue&type=script&lang=js&"
import style0 from "./exhibit.vue?vue&type=style&index=0&id=e010055e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e010055e",
  null
  
)

export default component.exports